import jwt_decode from "jwt-decode";

export const defaultScopeId = "v3.auth";

export const LOGIN_SUCCEEDED = "AUTH/LOGIN_SUCCEEDED";
export const LOGIN_FAILED = "AUTH/LOGIN_FAILED";
export const LOGIN_REQUESTED = "AUTH/LOGIN_REQUESTED";

export const LOGOUT_REQUESTED = "AUTH/LOGOUT_REQUESTED";
export const LOGOUT_SUCCESS = "AUTH/LOGOUT_SUCCESS";

export const LOGIN_MANUAL_REFRESH_REQUESTED = "AUTH/LOGIN_MANUAL_REFRESH_REQUESTED";
export const LOGIN_RELOGIN_REQUESTED = "AUTH/LOGIN_RELOGIN_REQUESTED";

export const TRIGGER_RESET_PASSWORD_SUCCEEDED = "AUTH/TRIGGER_RESET_PASSWORD_SUCCEEDED";
export const TRIGGER_RESET_PASSWORD_FAILED = "AUTH/TRIGGER_RESET_PASSWORD_FAILED";
export const TRIGGER_RESET_PASSWORD_REQUESTED = "AUTH/TRIGGER_RESET_PASSWORD_REQUESTED";

export const UPDATE_PASSWORD_SUCCEEDED = "AUTH/UPDATE_PASSWORD_SUCCEEDED";
export const UPDATE_PASSWORD_FAILED = "AUTH/UPDATE_PASSWORD_FAILED";
export const UPDATE_PASSWORD_REQUESTED = "AUTH/UPDATE_PASSWORD_REQUESTED";

export const UPDATE_PASSWORD_INAPP_SUCCEEDED = "AUTH/UPDATE_PASSWORD_INAPP_SUCCEEDED";
export const UPDATE_PASSWORD_INAPP_FAILED = "AUTH/UPDATE_PASSWORD_INAPP_FAILED";
export const UPDATE_PASSWORD_INAPP_REQUESTED = "AUTH/UPDATE_PASSWORD_INAPP_REQUESTED";

export const LOAD_CURRENT_USER_REQUESTED = "AUTH/LOAD_CURRENT_USER_REQUESTED";
export const LOAD_CURRENT_USER_SUCCEEDED = "AUTH/LOAD_CURRENT_USER_SUCCEEDED";
export const LOAD_CURRENT_USER_FAILED = "AUTH/LOAD_CURRENT_USER_FAILED";

export const REFRESH_SUCCEEDED = "AUTH/REFRESH_SUCCEEDED";

export const LOGIN_URL_REQUESTED = "AUTH/LOGIN_URL_REQUESTED";
export const LOGIN_URL_SUCCEEDED = "AUTH/LOGIN_URL_SUCCEEDED";
export const LOGIN_URL_FAILED = "AUTH/LOGIN_URL_FAILED";

export const TRIGGER_EMAIL_VERIFICATION_EMAIL = "AUTH/TRIGGER_EMAIL_VERIFICATION_EMAIL";
export const TRIGGER_BACK_TO_APPLICATION = "AUTH/TRIGGER_BACK_TO_APPLICATION";
export const REQUEST_ACCEPT_TERMS_AND_CONDITIONS = "AUTH/REQUEST_ACCEPT_TERMS_AND_CONDITIONS";

export const USER_CHANGED = "AUTH/USER_CHANGED";

export const ACCEPT_INVITE = "AUTH/ACCEPT_INVITE";

// eslint-disable-next-line complexity, max-statements
export default (
    state = {
        errors: [],
        hasInitialData: false,
        isShowingGlobalLoginModal: false,
        loading: 0,
        loginUrl: null,
        updating: 0,
        user: {},
        jwt: {}
    },
    { type, data }
) => {
    switch (type) {
    case LOGIN_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOGIN_FAILED: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case REFRESH_SUCCEEDED:
    case LOGIN_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.isShowingGlobalLoginModal = false;
        state.user = { ...state.user, ...data };
        return state;
    }
    case LOAD_CURRENT_USER_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_CURRENT_USER_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.isShowingGlobalLoginModal = false;
        state.user = { ...state.user, ...data };
        return state;
    }
    case LOAD_CURRENT_USER_FAILED: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case LOGIN_RELOGIN_REQUESTED: {
        state.isShowingGlobalLoginModal = true;
        return state;
    }
    case LOGOUT_SUCCESS: {
        --state.loading;
        state.isShowingGlobalLoginModal = true;
        state.user = undefined;
        return state;
    }
    case TRIGGER_EMAIL_VERIFICATION_EMAIL:
    case TRIGGER_BACK_TO_APPLICATION:
    case REQUEST_ACCEPT_TERMS_AND_CONDITIONS:
    case TRIGGER_RESET_PASSWORD_REQUESTED: {
        ++state.loading;
        console.log("TRIGGER RESET");
        return state;
    }
    case TRIGGER_RESET_PASSWORD_FAILED: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case TRIGGER_RESET_PASSWORD_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        return state;
    }
    case UPDATE_PASSWORD_INAPP_REQUESTED:
    case UPDATE_PASSWORD_REQUESTED: {
        ++state.loading;
        return state;
    }
    case UPDATE_PASSWORD_INAPP_FAILED:
    case UPDATE_PASSWORD_FAILED: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case UPDATE_PASSWORD_INAPP_SUCCEEDED:
    case UPDATE_PASSWORD_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        return state;
    }
    case LOGIN_URL_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOGIN_URL_SUCCEEDED: {
        --state.loading;
        state.loginUrl = data;
        return state;
    }
    case LOGIN_URL_FAILED: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case USER_CHANGED: {
        const {
            loggedIn,
            token,
            expiry,
            refreshExpiry,
            refreshToken,
            fullToken
        } = data;
        state.loggedIn = loggedIn;
        state.token = token;
        state.expiry = expiry;
        state.refreshExpiry = refreshExpiry;
        state.refreshToken = refreshToken;

        if (loggedIn && fullToken){
            const decodedToken = jwt_decode(fullToken);
            for (const key in decodedToken){
                state.jwt[key] = decodedToken[key];
            }
        } else {
            state.jwt = {};
        }

        return state;
    }
    case ACCEPT_INVITE:
    default:
        return state;
    }
};

export const successLoginUser = data => ({ type: LOGIN_SUCCEEDED, data });
export const failLoginUser = data => ({ type: LOGIN_FAILED, data });
export const requestLoginUser = (data, resolve, reject) => ({ type: LOGIN_REQUESTED, data, resolve, reject });

export const successTriggerResetUserPassword = data => ({ type: TRIGGER_RESET_PASSWORD_SUCCEEDED, data });
export const failTriggerResetUserPassword = data => ({ type: TRIGGER_RESET_PASSWORD_FAILED, data });
export const requestTriggerResetUserPassword = (data, resolve, reject) => ({ type: TRIGGER_RESET_PASSWORD_REQUESTED, data, resolve, reject });

export const successUpdateUserPassword = data => ({ type: UPDATE_PASSWORD_SUCCEEDED, data });
export const failUpdateUserPassword = data => ({ type: UPDATE_PASSWORD_FAILED, data });
export const requestUpdateUserPassword = (data, resolve, reject) => ({ type: UPDATE_PASSWORD_REQUESTED, data, resolve, reject });

export const successUpdateUserPasswordInApp = data => ({ type: UPDATE_PASSWORD_INAPP_SUCCEEDED, data });
export const failUpdateUserPasswordInApp = data => ({ type: UPDATE_PASSWORD_INAPP_FAILED, data });
export const requestUpdateUserPasswordInApp = (data, resolve, reject) => ({ type: UPDATE_PASSWORD_INAPP_REQUESTED, data, resolve, reject });

export const requestLogoutUser = () => ({ type: LOGOUT_REQUESTED });
export const successLogoutUser = () => ({ type: LOGOUT_SUCCESS });

export const requestRelogin = () => ({ type: LOGIN_RELOGIN_REQUESTED });

export const requestLoadCurrentUser = () => ({ type: LOAD_CURRENT_USER_REQUESTED });
export const successLoadCurrentUser = (data, resolve, reject) => ({ type: LOAD_CURRENT_USER_SUCCEEDED, data, resolve, reject });
export const failLoadCurrentUser = (data, resolve, reject) => ({ type: LOAD_CURRENT_USER_FAILED, data, resolve, reject });

export const requestLoginUrl = (data, resolve, reject) => ({ type: LOGIN_URL_REQUESTED, data, resolve, reject });
export const successLoginUrl = data => ({ type: LOGIN_URL_SUCCEEDED, data });
export const failLoginUrl = data => ({ type: LOGIN_URL_FAILED, data  });

export const requestAcceptTermsAndConditions = data => ({ type: REQUEST_ACCEPT_TERMS_AND_CONDITIONS, data });
export const requestTriggerEmailVerification = data => ({ type: TRIGGER_EMAIL_VERIFICATION_EMAIL, data });
export const requestTriggerBackToApplication = data => ({ type: TRIGGER_BACK_TO_APPLICATION, data });

export const userChanged = data => ({ type: USER_CHANGED, data });

export const acceptInviteUser = () => ({ type: ACCEPT_INVITE });
